import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SalesIcon from "@mui/icons-material/Storefront";
import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import useRenewTotalData from "@/hooks/data/use-renew-total-data";
import { IRenewTotal } from "@/interfaces/renew.interfaces";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import { RenewMessages } from "@/messages/renew/renew.messages";

type Props = {
  messages: RenewMessages;
  salesProductPrice: ISalesProductPrice;
  totalPayment: IRenewTotal;
};

function SubscriptionSummary({ messages, totalPayment }: Props) {
  const renewTotalData = useRenewTotalData({ renew: totalPayment });
  const { totalEventValue } = renewTotalData;
  const hasValue = (value?: number) => value !== undefined && value > 0;

  const feePerSalesValue = totalEventValue && hasValue(Number(totalEventValue));

  return (
    <MDBox display="flex" justifyContent="center" flexDirection="column" width="100%" gap={2}>
      <MDBox sx={{ width: "100%" }}>
        <Grid size={12}>
          <>
            <Divider />
            <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
              <MDBox display="flex" alignItems="center" gap={0.4}>
                <ShoppingCartIcon fontSize="medium" />
                <MDTypography variant="body2" fontWeight="regular">
                  {messages.signatureLabel}
                </MDTypography>
              </MDBox>
              <MDBox ml={1}>
                <MDTypography variant="body2" fontWeight="medium">
                  {renewTotalData.formattedTotalCustomerSalesProduct}
                </MDTypography>
              </MDBox>
            </MDBox>

            {!!feePerSalesValue && (
              <MDBox display="flex" alignItems="center" justifyContent="space-between" mt={3}>
                <MDBox display="flex" alignItems="center" gap={0.4}>
                  <SalesIcon fontSize="medium" />
                  <MDTypography variant="body2" fontWeight="light">
                    {messages.totalPerEventValueLabel}
                  </MDTypography>
                </MDBox>
                <MDBox ml={1}>
                  <MDTypography variant="body2" fontWeight="medium">
                    {renewTotalData.formattedTotalEventValue}
                  </MDTypography>
                </MDBox>
              </MDBox>
            )}

            <MDBox display="flex" alignItems="center" justifyContent="space-between" mt={3}>
              <MDBox display="flex" alignItems="center" gap={0.4}>
                <ShoppingCartIcon fontSize="medium" />
                <MDTypography variant="body1" fontWeight="light">
                  {messages.totalLabel}
                </MDTypography>
              </MDBox>
              <MDBox ml={1}>
                <MDTypography variant="body1" fontWeight="medium">
                  {renewTotalData.formattedTotalPaid}
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default SubscriptionSummary;
